module.exports = __webpack_public_path__ + "img/logo-app.c00bb810.svg";